import {BrandShopMeta} from '@aboutyou/logic-components';
import React from 'react';
import {BrandShopPage} from './BrandShopPage';

export const BrandPageLegacySwitch: React.FC = () => {
  // On the server we would waste resources if we render everything as the data is lost after the redirect that will happen.
  // On the client we can handle this more gracefully and just reuse the already requested data
  return process.browser ? <BrandShopPage /> : <BrandShopMeta />;
};
